import type { IconData } from '@stacksjs/iconify-core'

export const apps: IconData = {
  "body": "<rect width=\"9\" height=\"9\" x=\"2\" y=\"2\" fill=\"currentColor\" rx=\"1\"/><rect width=\"9\" height=\"9\" x=\"2\" y=\"13\" fill=\"currentColor\" opacity=\".5\" rx=\"1\"/><rect width=\"9\" height=\"9\" x=\"13\" y=\"2\" fill=\"currentColor\" opacity=\".5\" rx=\"1\"/><rect width=\"9\" height=\"9\" x=\"13\" y=\"13\" fill=\"currentColor\" opacity=\".5\" rx=\"1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default apps
